// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const EndpointApiTypeSchema = z.enum(['UNKNOWN','REST','GRAPHQL','SOAP','WEBSOCKET','GRPC'] as const);

export type EndpointApiTypeType = `${z.infer<typeof EndpointApiTypeSchema>}`

export default EndpointApiTypeSchema;
